// import { Message } from "element-ui";
import i18n from '@/Language'

/**
 * 防抖
 * @param {*} fn
 * @param {*} delay
 * @returns
 */
export let debounce = function (fn, delay) {
  let timer = null
  return function () {
    let content = this;
    let args = arguments;
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      fn.apply(content, args)
    }, delay)
  }
}

/**
 * 日期  ‘04-23’
 * @param {*} d
 * @returns
 */
export let monthDay = function (d) {
  let date = new Date(d)
  let month = date.getMonth() + 1
  month = month < 10 ? ('0' + month) : month
  let day = date.getDate()
  day = day < 10 ? ('0' + day) : day
  return month + '-' + day
}

/**
 * ["04-15","04-16","04-17","04-18","04-19","04-20","04-21"]
 * @returns
 */
export let sevenDay = function () {
  let date = new Date().valueOf() - 604800000
  let arr = []
  for (let i = 0; i < 7; i++) {
    arr.push(monthDay(date += 86400000))
  }
  return arr
}

/**
 * 不允许为空
 * @param {*} obj
 * @returns
 */
export let noEmpty = function (obj) {
  for (let i in obj) {
    if (!obj[i]) return i
  }
  return false
}

/**
 * 格式化echarts数据
 * @param {Array} arr
 */
export let formatEchartsData = function (arr) {
  let arrData = []
  for (var i in arr) {
    if (arr[i] != null) {
      let arr2 = []
      arr2.push(i)
      arr2.push(arr[i])
      arrData.push(arr2)
    } else {
      let arr2 = []
      arr2.push(i)
      arr2.push(0)
      arrData.push(arr2)
    }
  }
  return arrData
}


// 函数拷贝
// export const deepCopy = (obj = {}) => {
//     let newObj = null
//     // 判断是否需要继续进行递归
//     if (typeof obj == 'object' && obj !== null) {
//         newObj = obj instanceof Array ? [] : {}
//         // 进行下一层递归克隆
//         for (let i in obj) {
//             newObj[i] = deepCopy(obj[i])
//         }
//     } else {
//         newObj = obj
//     }
//     return newObj
// }
// 深拷贝
// export const deepClone = (obj) => {
//     var o;
//     // 如果  他是对象object的话  , 因为null,object,array  也是'object';
//     if (typeof obj === 'object') {

//         // 如果  他是空的话
//         if (obj === null) {
//             o = null;
//         }
//         else {
//             // 如果  他是数组arr的话
//             if (obj instanceof Array) {
//                 o = [];
//                 for (var i = 0, len = obj.length; i < len; i++) {
//                     o.push(deepClone(obj[i]));
//                 }
//             }
//             // 如果  他是对象object的话
//             else {
//                 o = {};
//                 for (var j in obj) {
//                     o[j] = deepClone(obj[j]);
//                 }
//             }

//         }
//     }
//     else {
//         o = obj;
//     }
//     return o;
// };

/**
 * 树形数据转换为列表
 */

export function flattenTree(tree, result = []) {
  for (const node of tree) {
    // 将当前节点添加到结果数组中
    result.push({
      id: node.id,
      label: node.label,
      parentId: node.parentId || null // 如果有父节点ID，则添加
    });

    // 如果有子节点，递归处理子节点
    if (node.children && node.children.length > 0) {
      // 为子节点添加父节点ID
      node.children.forEach(child => child.parentId = node.id);
      flattenTree(node.children, result);
    }
  }
  return result;
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
export function handleTree(data, id, parentId, children) {
    let config = {
        id: id || 'id',
        parentId: parentId || 'parentId',
        childrenList: children || 'children'
    };

  var childrenListMap = {};
  var nodeIds = {};
  var tree = [];

  for (let d of data) {
    let parentId = d[config.parentId];
    if (childrenListMap[parentId] == null) {
      childrenListMap[parentId] = [];
    }
    nodeIds[d[config.id]] = d;
    childrenListMap[parentId].push(d);
  }

  for (let d of data) {
    let parentId = d[config.parentId];
    if (nodeIds[parentId] == null) {
      tree.push(d);
    }
  }

  for (let t of tree) {
    adaptToChildrenList(t);
  }

  function adaptToChildrenList(o) {
    if (childrenListMap[o[config.id]] !== null) {
      o[config.childrenList] = childrenListMap[o[config.id]];
    }
    if (o[config.childrenList]) {
      for (let c of o[config.childrenList]) {
        adaptToChildrenList(c);
      }
    }
  }
  return tree;
}

export const flatArrayToTree = (flatData) => {
  const result = [];
  const map = {};
  try {
    // 先构建一个id映射表
    flatData.forEach((item, index) => {
      if (!item.id) {
        item.id = String(item.deviceType).slice(0, 3) + index
      }
      map[item.id] = { ...item, children: [] };
    });

    // 然后根据parentId将子节点添加到父节点的children属性下
    flatData.forEach(item => {
      if (item.parentId !== null && map[item.parentId]) {
        map[item.parentId].children.push(map[item.id]);
      } else {
        result.push(map[item.id]);
      }
    });
  } catch (err) {
    return flatData
  }

  return result;
}

export const handleTimeZone = (timeZone) => {
  if (![null, undefined, ''].includes(timeZone)) {
    if (timeZone > 0) {
      timeZone = `UTC+${timeZone}`;
    } else if (timeZone < 0) {
      timeZone = `UTC${timeZone}`;
    } else {
      timeZone = `UTC ${timeZone}`;
    }
    return timeZone;
  }
}

/*
 * 核心方法，实现加减乘除运算，确保不丢失精度
 * 思路：把小数放大为整数（乘），进行算术运算，再缩小为小数（除）
 * @param a {number} 运算数1
 * @param b {number} 运算数2
 * @param digits {number} 精度，保留的小数点数，比如 2, 即保留为两位小数
 * @param op {string} 运算类型，有加减乘除（add/subtract/multiply/divide）
 */

export const getLen = (num) => {
  let numStr = num.toString()
  return numStr.indexOf('.') === -1 ? 0 : numStr.split('.')[1].length
}

export const operation = (a, b, op, digits) => {
    var result = null
    const maxLen = Math.max(getLen(a), getLen(b));
    const base = Math.pow(10, maxLen);
    const bigA = Math.round(base * a);
    const bigB = Math.round(base * b);
    switch (op) {
        case 'add':
            result = bigA + bigB
            break
        case 'subtract':
            result = bigA - bigB
            break
        case 'multiply':
            // 乘法：结果被放大了 base² 倍
            result = bigA * bigB;
            // 需要除以 base² 来还原
            return result / (base * base);
            
        case 'divide':
            // 除法：结果已经正确（分子分母都有 base）
            result = bigA / bigB;
            // 直接返回，不需要再除以 base
            return result;
    }
    return result / base
}

// 加减乘除的四个接口

export const add = (a, b, digits) => {
  return operation(a, b, 'add', digits)
}

export const subtract = (a, b, digits) => {
  return operation(a, b, 'subtract', digits)
}

export const multiply = (a, b, digits) => {
  return operation(a, b, 'multiply', digits)
}

export const divide = (a, b, digits) => {
  return operation(a, b, 'divide', digits)
}

export const languageDropDown = (language) => {
  switch (language) {
    case '中文':
      return 'zh-CN';
    case 'English':
      return 'en-US';
    // case '繁體':
    //     return 'zh-HK';
    case 'Deutsch':
      return 'de-DE';
    case 'Italiano':
      return 'it-IT';
    case 'Українська Мова':
      return 'uk-UA';
    case 'Français':
      return 'fr-FR';
    case 'ภาษาไทย':
      return 'th-TH';
    default:
      return 'en-US';
  }
}

/**
 * 安全地获取或初始化 localStorage 数据
 * @param {string} storageKey - localStorage 的键名
 * @param {any} defaultValue - 默认值（如果不存在或解析失败）
 * @returns {any} 解析后的数据或默认值
 */
export const getOrInitLocalStorage = (storageKey, defaultValue) => {
  try {
    // 1. 尝试从 localStorage 获取数据
    const storedData = localStorage.getItem(storageKey);

    // 2. 如果数据不存在，存储默认值并返回
    if (storedData === null) {
      const dataToStore = JSON.stringify(defaultValue);
      localStorage.setItem(storageKey, dataToStore);
      return defaultValue;
    }

    // 3. 尝试解析数据
    const parsedData = JSON.parse(storedData);
    return parsedData;

  } catch (error) {
    console.error(`处理 localStorage 数据时出错 (key: ${storageKey}):`, error);

    // 4. 如果解析失败，存储默认值并返回
    try {
      const dataToStore = JSON.stringify(defaultValue);
      localStorage.setItem(storageKey, dataToStore);
    } catch (storageError) {
      console.error('存储默认值失败:', storageError);
    }

    return defaultValue;
  }
}

/**
 * 判断Wi-Fi信号强度等级
 * @param {string|number} wifiSignal - Wi-Fi信号强度值（如"-58"）
 * @returns {string} 信号强度等级：'强' | '中' | '弱'
 */
export const getWifiSignalLevel = (wifiSignal) => {
  if (!wifiSignal) return 'unKnow'
  // 转换为数字类型
  const signal = typeof wifiSignal === 'string'
    ? parseFloat(wifiSignal)
    : Number(wifiSignal);

  // 检查是否为有效数字
  if (isNaN(signal)) {
    throw new Error('Invalid Wi-Fi signal value');
  }

  // 判断信号强度等级
  if (signal >= -50) {
    return 'Strong';
  } else if (signal >= -75) {
    return 'Medium';
  } else if (signal >= -113) {
    return 'Weak';
  } else {
    return 'unKnow';
  }
}

export const downloadFile = (response, fileName = 'exported_file') => {
  const blob = new Blob([response], {
    type: 'application/vnd.ms-excel',
  });
  const blobUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.style.display = 'none';
  link.href = blobUrl;
  link.download = `${fileName}.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export const copyToClipboard = (text) => {
    // 方法1：现代API（安全上下文https下生效）
    if (navigator.clipboard) {
        return navigator.clipboard.writeText(text)
            .then(() => true)
            .catch(err => {
                console.error('复制失败:', err);
                return false;
            });
    }

  // 方法2：兼容旧版浏览器的备用方案
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.style.position = 'fixed'; // 避免触发滚动
  document.body.appendChild(textarea);
  textarea.select();

  try {
    const successful = document.execCommand('copy');
    document.body.removeChild(textarea);
    return successful ? true : false;
  } catch (err) {
    console.error('复制失败:', err);
    document.body.removeChild(textarea);
    return false;
  }
}

// 工具函数：安全获取显示文本
export const getDisplayText = (key, mapping = {}, fallback = '-') => {
    if (key === null || key === '' || key === undefined) return fallback; // 处理 null, undefined, 空字符串
    return mapping[key] ?? key ?? fallback;
}


// 功率单位：mW、W、kW、MW、GW、TW
// 电量单位：mWh、Wh、kWh、MWh、GWh、TWh
export const energyUnitConverter = {
  conversionFactors: {
    kWh: 1,
    MWh: 1e3,
    GWh: 1e6,
    TWh: 1e9
  },


  convert(value, fromUnit, toUnit) {
    const validUnits = Object.keys(this.conversionFactors);
    if (!validUnits.includes(fromUnit) || !validUnits.includes(toUnit)) {
      throw new Error(`Invalid unit. Valid units are: ${validUnits.join(', ')}`);
    }

    const baseValue = value * this.conversionFactors[fromUnit];
    return baseValue / this.conversionFactors[toUnit];
  },

  format(value, unit, precision = 2) {
    return `${value.toFixed(precision)} ${unit}`;
  },
  // 电量单位自动转化
  // unitConvert(value, extent = 100000, Unit = 'kWh') {
  // 	const variable = value ?? '--';
  // 	if (variable == '--') return {
  // 		value: variable,
  // 		unit: Unit
  // 	}
  // 	const validUnits = Object.keys(this.conversionFactors);
  // 	let i = validUnits.indexOf(Unit)
  // 	let num = Number(value)
  // 	if (value > extent && i + 1 < validUnits.length ) {
  // 		const baseValue = value * this.conversionFactors[Unit];
  // 		 num = baseValue / this.conversionFactors[validUnits[ i + 1]];
  // 		return this.unitConvert(num, extent, validUnits[i + 1])
  // 	} else {
  // 		return {
  // 			// 先固定精度 // 去除无意义的小数部分 // 去除末尾的连续零
  // 			value: num.toFixed(1).replace(/\.?0+$/, '').replace(/(\.\d*?[1-9])0+$/, '$1'),
  // 			unit: Unit
  // 		}
  // 	}
  // }
  unitConvert(value, extent = 100000, Unit = 'kWh') {
    const variable = value ?? '--';
    if (variable === '--') return {
      value: variable,
      unit: Unit
    };

    // 检查是否为负数
    const isNegative = value < 0;
    const absoluteValue = Math.abs(Number(value));
    const validUnits = Object.keys(this.conversionFactors);
    let i = validUnits.indexOf(Unit);
    let num = absoluteValue;

    if (absoluteValue > extent && i + 1 < validUnits.length) {
      const baseValue = absoluteValue * this.conversionFactors[Unit];
      num = baseValue / this.conversionFactors[validUnits[i + 1]];
      const result = this.unitConvert(num, extent, validUnits[i + 1]);
      return {
        value: isNegative ? `-${result.value}` : result.value,
        unit: result.unit
      };
    } else {
      return {
        // 先固定精度 // 去除无意义的小数部分 // 去除末尾的连续零
        value: (isNegative ? '-' : '') + num.toFixed(2).replace(/\.?0+$/, '').replace(/(\.\d*?[1-9])0+$/,
          '$1'),
        unit: Unit
      }
    }
  }
};

// 使用示例：
// 转换1500 kWh到MWh
// const result = energyUnitConverter.convert(1500, 'kWh', 'MWh'); // 1.5
// const formatted = energyUnitConverter.format(result, 'MWh'); // "1.50 MWh"
// const unitNum = energyUnitConverter.unitConvert(848778856733, 100000); // {"value":"848.78","unit":"TWh"}

/**
 * 单位转换，通过配置,默认3为整数，2为小数
 * @param {*} value 要转换的值
 * @param {*} key 单位配置的key
 * @param {*} config 转换配置，默认{integer: 3 整数位数, decimal: 2 小数位数}
 * @returns {value, unit}
 */
export const convertUnit = (value, key = 'weight', config = {
  integer: 3,
  decimal: 1
}) => {
  const unitOption = {
		weight: [{
        unit: 'g',
        value: 1 / 1000
      },
      {
        unit: 'kg', // 单位名称
        value: 1, // 倍率
      },
      {
        unit: 't',
        value: 1000,
      },
      {
        unit: 'kt', // 千吨
        value: 1000 * 1000 , // 1000 * 1000 t
      },
      {
        unit: 'wt', // 万吨
        value: 1000 * 10000, // 1000 * 10000 kt
      },
      {
        unit: 'mt', // 兆吨
        value: 1000 * 1000 * 1000, // 1000 * 1000000 wt
      }
    ]


  }
  for (let index = 0; index < unitOption[key].length; index++) {
    const item = unitOption[key][index];
    let data = value / item.value;
    const strList = `${data}`.split('.');
    data = data.toFixed(config.decimal)
    if (strList[0].length <= config.integer || index === unitOption[key].length - 1) {
      return {
        value: data,
        unit: item.unit
      }
    }
  }
  return {
    value: value,
    unit: unitOption[key][unitOption[key].length - 1].unit
  }
}

/** 单位换算阶梯配置：value 为相对基准单位的倍率，整数部分超过 integer 位时自动升档 */
const CONVERT_UNIT_BY_CONFIG_OPTION = {
  weight: [
    {
      unit: 'kg',
      value: 1,
    },
    {
      unit: 't',
      value: 1000,
    },
    {
      unit: 'kt', // 千吨
      value: 1000000,
    },
    {
      unit: 'wt',
      value: 10000000,
    },
    {
      unit: 'Mt', // 兆吨
      value: 1000000000,
    },
  ],
  num: [
    {
      unit: '',
      value: 1,
    },
    {
      unit: 'k', // 千
      value: 1e3,
    },
    {
      unit: 'M', // 百万
      value: 1e6,
    },
    {
      unit: 'B', // 十亿
      value: 1e9,
    },
    {
      unit: 'T', // 万亿
      value: 1e12,
    },
  ],
  // 基准单位为 kWh，整数超过 3 位自动升档
  energy: [
    {
      unit: 'kWh',
      value: 1,
    },
    {
      unit: 'MWh',
      value: 1e3,
    },
    {
      unit: 'GWh',
      value: 1e6,
    },
    {
      unit: 'TWh',
      value: 1e9,
    },
  ],
};

/** convertUnitByConfig 默认参数：整数最多 3 位、保留 1 位小数，负数按 0 处理 */
const CONVERT_UNIT_BY_CONFIG_DEFAULT = {
  integer: 3,
  decimal: 1,
  negativeToZero: true,
};

/**
 * 单位转换，通过配置自动选择合适单位
 * @param {*} value 要转换的值
 * @param {string} key 单位类型，weight（重量）、num（数量）或 energy（电量，基准 kWh）
 * @param {Object} config 转换配置
 * @param {number} [config.integer=3] 整数位数上限，超出则升档
 * @param {number} [config.decimal=1] 小数位数
 * @param {boolean} [config.negativeToZero=true] value 小于 0 时是否返回 0
 * @returns {{ value: string, unit: string }}
 */
export const convertUnitByConfig = (value, key = 'weight', config = {}) => {
  const cfg = { ...CONVERT_UNIT_BY_CONFIG_DEFAULT, ...config };
  const list = CONVERT_UNIT_BY_CONFIG_OPTION[key];
  if (!list) {
    return { value: String(value ?? ''), unit: '' };
  }
  if (cfg.negativeToZero && value < 0) {
    return {
      value: (0).toFixed(cfg.decimal),
      unit: list[0].unit,
    };
  }
  for (let index = 0; index < list.length; index++) {
    const item = list[index];
    let data = value / item.value;
    const strList = `${data}`.split('.');
    data = data.toFixed(cfg.decimal);
    if (strList[0].length <= cfg.integer || index === list.length - 1) {
      return {
        value: data,
        unit: item.unit,
      };
    }
  }
  return {
    value: value,
    unit: list[list.length - 1].unit,
  };
};

export const vacancy = function (variable) {
  // 如果variable是null或undefined，则返回'default'，否则返回variable的值
  const value = variable ?? '--';
  return value
}

/**
 * 计算表格高度，根据页面高度、搜索框高度和其他固定高度来动态调整
 * @param {Object} refs - Vue组件的refs对象
 * @param {number} fixHeight - 固定高度（包括头部、底部等）
 * @param {number} additionalOffset - 额外偏移量，默认为0
 * @returns {number} 计算得出的表格高度
 */
export const calculateTableHeight = (refs, fixHeight, additionalOffset = 0) => {
  // 获取当前页面高度
  const pageHeight = document.documentElement.clientHeight;

  // 获取搜索框高度，因为会根据展开收起发生变化
  const searchHeight = refs.searchForm?.$el?.clientHeight || 0;

  // 计算表格高度
  return pageHeight - searchHeight - fixHeight - additionalOffset;
};

export const downloadFileName = (response) => {
  // 1. 从 Content-Disposition 头中提取文件名
  const contentDisposition = response.headers['content-disposition'];
  let filename = 'exported_file.xlsx'; // 默认名

  if (contentDisposition) {
    const filenameMatch = contentDisposition.match(/filename\*?=['"]?(?:UTF-\d['"]*)?([^;\r\n"']*)['"]?/i);
    if (filenameMatch && filenameMatch[1]) {
      filename = decodeURIComponent(filenameMatch[1].replace(/\+/g, ' '));
      filename = filename.substring(filename.lastIndexOf('/') + 1).substring(filename.lastIndexOf('\\') + 1);
    }
  }
  // 2. 获取 blob
  const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
  return { blob, filename };
}

export const downLoadFileN = (blob, fileName = 'exported_file.xlsx') => {
  const blobUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.style.display = 'none';
  link.href = blobUrl;
  link.download = fileName || `exported_file.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(blobUrl);
}

// 将时间转换为区间格式的函数
export const formatTimeRange = (timeStr) => {
  if (!timeStr) return '';

  // 匹配 HH:mm 格式的时间
  const timeMatch = timeStr.match(/(\d{1,2}):(\d{2})/);
  if (!timeMatch) return timeStr; // 如果不是标准时间格式，返回原值

  const hour = parseInt(timeMatch[1]);
  const minute = parseInt(timeMatch[2]);

  // 计算起始时间
  let startHour = hour;
  let startMinute = minute;

  // 如果是整点，前推一小时
  if (minute === 0) {
    startHour = hour - 1;
    if (startHour < 0) startHour = 23;
    startMinute = 0;
  } else {
    // 如果不是整点，根据业务逻辑处理
    // 这里假设你想要的时间段是上一整点到当前整点
    startHour = hour;
    startMinute = 0;
  }

  // 格式化时间为两位数
  const formatTwoDigits = (num) => num.toString().padStart(2, '0');

  return `${formatTwoDigits(startHour)}:${formatTwoDigits(startMinute)}-${formatTwoDigits(hour)}:${formatTwoDigits(minute)}`;
}

let routeHistory = []
let isGoingBack = false
let _routeSourceMap = new Map()

export const getRouteHistory = () => routeHistory

export const getIsGoingBack = () => isGoingBack

export const setRouteSource = (routeName, from) => {
  // if(_routeSourceMap.has(routeName)) return
  if (routeName && from && from.fullPath) {
    _routeSourceMap.set(routeName, {
      path: from.fullPath,
      name: from.name,
      params: { ...from.params },
      query: { ...from.query }
    })
  }
}

export const getRouteSource = (routeName) => _routeSourceMap.get(routeName) || null

export const clearRouteSource = (routeName) => _routeSourceMap.delete(routeName)

export const addToRouteHistory = (from) => {
  // 如果是返回操作，不记录
  if (isGoingBack) {
    isGoingBack = false // 重置标志
    return
  }

  if (from && from.name) {
    routeHistory.push({
      path: from.fullPath,
      name: from.name,
      params: { ...from.params },
      query: { ...from.query },
      timestamp: Date.now()
    })

    // 限制历史记录长度
    if (routeHistory.length > 50) {
      routeHistory.shift()
    }
  }
}

export const safeGoBack = (router, fallbackRoute = '/home') => {
  const referrer = document.referrer
  const currentOrigin = window.location.origin

  // 情况1：没有referrer且没有历史记录
  if (!referrer && routeHistory.length <= 0) {
    router.push(fallbackRoute)
    return
  }

  // 情况2：referrer来自其他网站且没有历史记录
  if (referrer && !referrer.startsWith(currentOrigin) && routeHistory.length <= 0) {
    router.push(fallbackRoute)
    return
  }

  try {
    // 检查是否可以安全返回
    if (routeHistory.length > 0) {
      // 设置标志位，防止记录返回操作
      isGoingBack = true

      // 先移除当前路由记录
      routeHistory.pop()

      // 执行返回操作
      router.go(-1)
    } else {
      router.push(fallbackRoute)
    }
  } catch (error) {
    console.warn('路由返回失败:', error)
    router.push(fallbackRoute)
  }
}

export const resrfuntion = () => {

  const elOptions = document.querySelectorAll('.el-select-dropdown');
  const style = window.getComputedStyle(document.body);

  // Get the transform property
  const transform = style.transform;

  // Parse the scale value from the transform matrix
  let scale = 1; // Default value
  if (transform && transform !== 'none') {
    // transform value looks like "matrix(0.510938, 0, 0, 0.510938, 0, 0)"
    const matrix = transform.match(/matrix\(([^)]+)\)/);
    if (matrix) {
      const values = matrix[1].split(', ');
      scale = parseFloat(values[0]); // The first value in the matrix is the scaleX
      // console.log(scale,'13213123123')

      document.documentElement.style.setProperty('--popup-scale', 1 / scale);
      let borderwidth = 2
      if (scale < 0.5) {
        borderwidth = 3
      }
      document.documentElement.style.setProperty('--border-width', borderwidth + 'px');

    }
  }



  // 获取 --popup-scale CSS 变量值
  const popupScale = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--popup-scale').trim());

  // 遍历 el-option 元素，计算宽度并乘以 popupScale
  elOptions.forEach(option => {
    const width = option.style.minWidth; // 获取宽度
    const scaledWidth = parseFloat(width.replace('px', '')) * popupScale; // 乘以 popup-scale
    // 可选：将计算结果存储或应用到元素
    // 例如：option.style.width = `${scaledWidth}px`;
    option.style.width = `${scaledWidth}px`
  });
}
/**
 * 生成时间数组
 * @param {string} startTime - 起始时间，格式为 "HH:mm"
 * @param {number} duration - 持续时间（小时）
 * @param {number} interval - 时间间隔（分钟）
 * @param {boolean} includeEnd - 是否包含结束时间
 * @param {boolean} replaceMidnightWith24 - 是否将 "00:00" 替换为 "24:00"
 * @returns {string[]} - 时间数组
 */
export const generateTimeArray = function (startTime, duration, interval, includeEnd = false, replaceMidnightWith24 = false) {
    const result = [];
    const [startHour, startMinute] = startTime.split(':').map(Number);
    const totalMinutes = duration * 60; // 持续时间转换为分钟
    const startTotalMinutes = startHour * 60 + startMinute; // 起始时间转换为分钟
    const endTotalMinutes = startTotalMinutes + totalMinutes; // 结束时间（分钟）

    let currentMinutes = startTotalMinutes;

    while (currentMinutes < endTotalMinutes) {
        const hours = Math.floor((currentMinutes % 1440) / 60); // 计算小时（支持跨天）
        const minutes = currentMinutes % 60; // 计算分钟
        let time = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
        // 仅在非起始时间时替换 "00:00" 为 "24:00"
        if (replaceMidnightWith24 && time === "00:00" && currentMinutes !== startTotalMinutes) {
            time = "24:00";
        }
        result.push(time);
        currentMinutes += interval; // 增加时间间隔
    }

    if (includeEnd) {
        const endHours = Math.floor((endTotalMinutes % 1440) / 60);
        const endMinutes = endTotalMinutes % 60;
        let endTime = `${String(endHours).padStart(2, '0')}:${String(endMinutes).padStart(2, '0')}`;
        if (replaceMidnightWith24 && endTime === "00:00") {
            endTime = "24:00"; // 替换 "00:00" 为 "24:00"
        }
        result.push(endTime);
    }

    return result;
};

export const isEmpty = (value) => {
  return value === undefined || value === null || value === '';
}

// 处理空数据，为空时返回 '-'
export const handleEmptyData = (data) => {
  return isEmpty(data) ? '-' : data
}

// 统一处理组件输入精度
export const handleInputPrecision = (item) => {
  let precision = 2;
  if (!isEmpty(item.precision)) {
    precision = Number(item.precision);
  } else if (item.step) {
    precision = item.step.toString().split('.').pop().length || 2;
  }
  return precision;
}

export const commonOpenCookiePolicy = () => {
  const which = localStorage.getItem('Accept-Language') || 'en-US';
  let tlUrl = '';
  if (which === 'zh-CN') {
    tlUrl = "/resources/web/haier-energy_cookiePolicy_zh.html";
  } else {
    tlUrl = "/resources/web/haier-energy_cookiePolicy_en.html";
  }
  window.open(tlUrl, '_blank');
}

// 处理设备名称逻辑抽离
export const handleDeviceName = (row) => {
  if (row.changeNameCount === 1) {
    return row.datalogName || '';
  } else {
    return (row.deviceTypeStr || '') + (row.hrSn ? row.hrSn.slice(-4) : '');
  }
}

/**
 * 自动选择合适的单位前缀并格式化数值
 * @param {number} value - 原始数值（支持正数、负数、0）
 * @param {Object} [options] - 配置选项
 * @param {number} [options.precision=2] - 小数保留位数
 * @param {boolean} [options.returnObject=false] - 是否返回 {value, unit} 对象，默认为 false（返回字符串）
 * @param {string} [options.separator=''] - 数值与单位之间的分隔符，默认无空格
 * @returns {string|Object} 格式化后的字符串或 {value, unit} 对象
 *
 * @example
 * siUnitConverter.autoUnit(1000)                      // "1k"
 * siUnitConverter.autoUnit(1234567)                   // "1.23M"
 * siUnitConverter.autoUnit(1234567, { precision: 0 }) // "1M"
 * siUnitConverter.autoUnit(-5000000)                  // "-5M"
 * siUnitConverter.autoUnit(0.5)                       // "0.5"
 * siUnitConverter.autoUnit(1234, { returnObject: true }) // { value: 1.23, unit: 'k' }
 */
export const siUnitConverter = {
  units: ['T', 'G', 'M', 'k', ''],
  unitValues: { 'T': 1e12, 'G': 1e9, 'M': 1e6, 'k': 1e3, '': 1 },

  /**
   * @param {number|null|undefined} value
   * @param {number} [extent=10000]
   * @param {string} [unit='']
   * @param {Object} [options]
   * @param {number} [options.precision=1] - 小数位数，设为 0 则不保留小数（取整）
   * @returns {{value: string|number, unit: string}}
   */
  unitConvert(value, extent = 10000, unit = '', options = { precision: 1 }) {
    const { precision } = options;

    if (value === null || value === undefined || isNaN(value)) {
      return { value: '--', unit: unit || '' };
    }

    const isNegative = value < 0;
    let absValue = Math.abs(value);
    const currentUnitValue = this.unitValues[unit] || 1;
    let baseValue = absValue * currentUnitValue;

    let currentIdx = this.units.indexOf(unit);
    if (currentIdx === -1) currentIdx = this.units.length - 1;

    const upgrade = (val, idx) => {
      if (idx === 0) return { value: val, unit: this.units[0] };
      if (val >= extent) {
        const nextUnit = this.units[idx - 1];
        const nextValue = val / (this.unitValues[nextUnit] / this.unitValues[this.units[idx]]);
        return upgrade(nextValue, idx - 1);
      }
      return { value: val, unit: this.units[idx] };
    };

    let result = upgrade(baseValue, currentIdx);
    let finalValue = result.value;
    let finalUnit = result.unit;

    // 根据 precision 格式化
    let formattedValue;
    if (precision === 0) {
      // 不保留小数：四舍五入取整
      formattedValue = Math.round(finalValue).toString();
    } else {
      // 保留指定小数位，并去除尾随零
      formattedValue = finalValue.toFixed(precision).replace(/\.?0+$/, '');
      // console.log('precision',precision,' 保留指定小数位，并去除尾随零', formattedValue);
    }

    if (finalValue === 0) formattedValue = '0';
    if (isNegative && formattedValue !== '0') {
      formattedValue = '-' + formattedValue;
    }

    return { value: formattedValue, unit: finalUnit };
  }
};
/**
 * 中文单位转换器（万、亿、万亿）
 * 基于递归升级逻辑，阈值默认 10000
 */
export const chineseUnitConverter = {
  // 中文单位列表（从大到小排列）
  units: ['万亿', '亿', '万', ''],
  // 单位对应的数值倍数（基准为无单位）
  unitValues: {
    '万亿': 1e12,
    '亿': 1e8,
    '万': 1e4,
    '': 1
  },

  /**
   * 自动选择合适的中文单位并格式化数值
   * @param {number|null|undefined} value - 原始数值（支持正数、负数、0）
   * @param {number} [extent=10000] - 触发单位升级的阈值（绝对值），默认 10000（即 1 万）
   * @param {string} [unit=''] - 当前数值的单位（如 '万'、'亿'），默认为空（无单位）
   * @param {Object} [options] - 配置选项
   * @param {number} [options.precision=1] - 小数保留位数，设为 0 则取整
   * @returns {{value: string, unit: string}} 返回 {value, unit} 对象
   *
   * @example
   * chineseUnitConverter.unitConvert(5000)       // { value: "5000", unit: "" }
   * chineseUnitConverter.unitConvert(10000)      // { value: "1", unit: "万" }
   * chineseUnitConverter.unitConvert(12345678)   // { value: "1234.6", unit: "万" } ？实际会升级到亿
   * chineseUnitConverter.unitConvert(12345678)   // { value: "0.1", unit: "亿" } 取决于阈值
   * chineseUnitConverter.unitConvert(150000000)  // { value: "1.5", unit: "亿" }
   * chineseUnitConverter.unitConvert(-100000000) // { value: "-1", unit: "亿" }
   * chineseUnitConverter.unitConvert(null)       // { value: "--", unit: "" }
   */
  unitConvert(value, extent = 10000, unit = '', options = { precision: 1 }) {
    const { precision } = options;

    // 空值处理
    if (value === null || value === undefined || isNaN(value)) {
      return { value: '--', unit: unit || '' };
    }

    const isNegative = value < 0;
    let absValue = Math.abs(value);
    const currentUnitValue = this.unitValues[unit] || 1;
    // 转换为基准单位（无单位）下的绝对值
    let baseValue = absValue * currentUnitValue;

    // 找到当前单位在 units 数组中的索引
    let currentIdx = this.units.indexOf(unit);
    if (currentIdx === -1) currentIdx = this.units.length - 1; // 默认无单位

    // 递归升级函数（完全模仿原逻辑）
    const upgrade = (val, idx) => {
      // 如果已经是最顶层单位（万亿），不再升级
      if (idx === 0) return { value: val, unit: this.units[0] };
      // 判断当前单位下的数值是否达到阈值
      if (val >= extent) {
        const nextUnit = this.units[idx - 1];
        // 计算升级后的数值：当前值 / (下一级单位倍数 / 当前级单位倍数)
        const nextValue = val / (this.unitValues[nextUnit] / this.unitValues[this.units[idx]]);
        return upgrade(nextValue, idx - 1);
      }
      return { value: val, unit: this.units[idx] };
    };

    let result = upgrade(baseValue, currentIdx);
    let finalValue = result.value;
    let finalUnit = result.unit;

    // 根据 precision 格式化数值
    let formattedValue;
    if (precision === 0) {
      // 不保留小数：四舍五入取整
      formattedValue = Math.round(finalValue).toString();
    } else {
      // 保留指定小数位，并去除尾随零
      formattedValue = finalValue.toFixed(precision).replace(/\.?0+$/, '');
    }

    // 处理零值
    if (finalValue === 0) formattedValue = '0';
    // 恢复符号
    if (isNegative && formattedValue !== '0') {
      formattedValue = '-' + formattedValue;
    }

    return { value: formattedValue, unit: finalUnit };
  }
};
export const chineseWeightConverter = {
  // 中文单位列表（从大到小排列）'克'
  units: ['兆吨', '万吨', '千吨', '吨', '千克', ],
  // 单位对应的数值倍数（基准单位：千克）
  unitValues: {
    '兆吨': 1e9,   // 1 兆吨 = 1e9 千克
    '万吨': 1e7,   // 1 万吨 = 1e7 千克
    '千吨': 1e6,   // 1 千吨 = 1e6 千克
    '吨': 1000,    // 1 吨 = 1000 千克
    '千克': 1,      // 基准单位
    // '克': 0.001    // 1 克 = 0.001 千克
  },

  /**
   * 自动选择合适的中文重量单位并格式化数值
   * @param {number|null|undefined} value - 原始数值（单位：千克）
   * @param {number} [extent=10000] - 触发单位升级的阈值（相对于当前单位下的数值）
   * @param {string} [unit='千克'] - 当前数值的单位（中文，如 '吨'），默认为 '千克'
   * @param {Object} [options] - 配置选项
   * @param {number} [options.precision=2] - 小数保留位数，设为 0 则取整
   * @returns {{value: string, unit: string}}
   *
   * @example
   * chineseWeightConverter.unitConvert(500)        // { value: "500", unit: "千克" }
   * chineseWeightConverter.unitConvert(1500)       // { value: "1.5", unit: "吨" }
   * chineseWeightConverter.unitConvert(12345)      // { value: "12.35", unit: "吨" }
   * chineseWeightConverter.unitConvert(10000000)   // { value: "1", unit: "万吨" }
   * chineseWeightConverter.unitConvert(1e9)        // { value: "1", unit: "兆吨" }
   * chineseWeightConverter.unitConvert(-15000000)  // { value: "-1.5", unit: "万吨" }
   */
  unitConvert(value, extent = 10000, unit = '千克', options = { precision: 2 }) {
    const { precision } = options;

    // 空值处理
    if (value === null || value === undefined || isNaN(value)) {
      return { value: '--', unit: unit || '' };
    }

    const isNegative = value < 0;
    let absValue = Math.abs(value);
    const currentUnitValue = this.unitValues[unit] ?? 1;
    // 转换为基准单位（千克）下的绝对值
    let baseValue = absValue * currentUnitValue;

    // 找到当前单位在 units 数组中的索引（从大到小）
    let currentIdx = this.units.indexOf(unit);
    if (currentIdx === -1) currentIdx = this.units.length - 1; // 默认最小单位（克）

    // 递归升级函数（从当前单位向更大单位尝试）
    const upgrade = (val, idx) => {
      // 已经达到最大单位（兆吨）
      if (idx === 0) return { value: val, unit: this.units[0] };
      if (val >= extent) {
        const nextUnit = this.units[idx - 1];
        const currentUnitVal = this.unitValues[this.units[idx]];
        const nextUnitVal = this.unitValues[nextUnit];
        // 升级后的数值 = 当前数值 * (当前单位倍率 / 下一级单位倍率)
        const nextValue = val * (currentUnitVal / nextUnitVal);
        return upgrade(nextValue, idx - 1);
      }
      return { value: val, unit: this.units[idx] };
    };

    // 当前数值是以当前单位表示的，需要先计算出以当前单位表示的数值
    let currentValue = baseValue / currentUnitValue;
    let result = upgrade(currentValue, currentIdx);
    let finalValue = result.value;
    let finalUnit = result.unit;

    // 格式化数值
    let formattedValue;
    if (precision === 0) {
      formattedValue = Math.round(finalValue).toString();
    } else {
      formattedValue = finalValue.toFixed(precision).replace(/\.?0+$/, '');
    }
    if (finalValue === 0) formattedValue = '0';
    if (isNegative && formattedValue !== '0') formattedValue = '-' + formattedValue;

    return { value: formattedValue, unit: finalUnit };
  }
};
// 处理tips提示信息，单标题，多行
 export const handleConfirmTipFormat = (tipTitle, type = 'single') => {
  if (type === 'single') {
    return tipTitle.split('\n')  // 按行分割
      .map((line, index) => {
      const trimmed = line.trim()
      // 索引从0开始，所以偶数行（0,2,4...）是需要加粗的标题行
      if (index === 0) {
          return `<span style="font-size: 14px;">${trimmed}</span>`
      }
        // 奇数行是描述内容，保持原样
        return `<span style="display: inline-block; margin: 8px 0; color: #999999;">${trimmed}</span>`
      })
      .join('<br>')// 用换行标签连接，保留视觉分行
  }
  return tipTitle
      .split('\n')  // 按行分割
      .map((line, index) => {
      const trimmed = line.trim()
      // 索引从0开始，所以偶数行（0,2,4...）是需要加粗的标题行
      if (index % 2 === 0) {
          return `<span style="font-size: 14px;">${trimmed}</span>`
      }
        // 奇数行是描述内容，保持原样
        return `<span style="display: inline-block; margin: 8px 0; color: #999999;">${trimmed}</span>`
      })
      .join('<br>')// 用换行标签连接，保留视觉分行
        
 }

// 判断是否为Element UI图标
export const isElementIcon = (icon) => {
  return icon && icon.startsWith('el-')
}

// 判断是否为图片文件名
export const hasImageExtension = (filename) => {
  return /\.(png|jpe?g|gif|bmp|webp)$/i.test(filename);
}

// 获取图标URL
export const getIconUrl = (icon, onError) => {
  if (!icon) return ''
  
  if (!icon.startsWith('el-')) {
    try {
      const iconPath = hasImageExtension(icon) ? icon : `${icon}.png`
      return require(`@/assets/img/${iconPath}`)
    } catch (error) {
      const msg = `图标不存在: ${icon}`
      if (typeof onError === 'function') {
        onError(msg)
      }
      return 'el-icon-warning'
    }
  }
  return ''
}

export const validateSectionGroupCount = (iotIdConfigMap, filteredFormData) => {
  const errors = []

  for (const iotId in filteredFormData) {
    const config = iotIdConfigMap[iotId]
    if (!config || config.type !== 'ordered_section_group') continue

    const data = filteredFormData[iotId]
    if (data && data._uiState && data._uiState.touVisibleCount !== undefined) {
      const count = data._uiState.touVisibleCount
      const minItems = config.minItems || 0
      const maxItems = config.maxItems || Infinity

      if (count < minItems) {
        errors.push(`${i18n.t(config.label)}: ${i18n.t('physicalModels.minItemsTip', { scope: minItems })}`)
      }
      if (count > maxItems) {
        errors.push(`${i18n.t(config.label)}: ${i18n.t('physicalModels.maxItemsTip', { scope: maxItems })}`)
      }
    } else {
      const minItems = config.minItems || 0
      if (minItems > 0) {
        errors.push(`${i18n.t(config.label)}: ${i18n.t('physicalModels.minItemsTip', { scope: minItems })}`)
      }
    }
  }

  return errors
}

export const validateFilteredDataEmptyFields = (iotIdConfigMap, filteredData, excludePattern) => {
  const errors = []
  const findEmptyFields = (obj, path = '') => {
    for (const key in obj) {
      // touConfig下发时，不做校验，因为保存时已经校验了 
      if (excludePattern && excludePattern.test(key)) continue
      const value = obj[key]
      const config = iotIdConfigMap[key]
      const currentPath = path ? `${path}.${key}` : key

      if (value === null || value === undefined || value === '' || value === "undefined" || value === "null") {
        if (key !== '_uiState') {
          errors.push(`${i18n.t('physicalModels.Empty', { scope: i18n.t(config.label) })}`)
        }
      } else if (typeof value === 'object' && !Array.isArray(value)) {
        findEmptyFields(value, currentPath)
      } else if (Array.isArray(value)) {
        value.forEach((item, index) => {
          if (item && typeof item === 'object') {
            findEmptyFields(item, `${currentPath}[${index}]`)
          }
        })
      }
    }
  }

  findEmptyFields(filteredData)
  return errors
}

// 递归遍历features,如果遇到type类型为ordered_section_group,则将virtualId替换为IoTId
export const JSONFeatruesBuild = (config) => {
  const features = config.features || []
  
  const traverseConfig = (items) => {
    items.forEach(item => {
      if (item.virtualId) {
        item.IoTId = item.virtualId
      }
      // 处理 steps 类型，将其转换为 sections 类型
      if (item.steps) {
        item.sections = item.steps
        delete item.steps
      }
      if (item.properties) {
        traverseConfig(item.properties)
      } else if (item.fields) {
        traverseConfig(item.fields)
      } else if (item.sections) {
        item.sections.forEach(section => {
          if (section.fields) {
            traverseConfig(section.fields)
          }
        })
      }
    })
  }
  traverseConfig(features)
  return config
}

/**
 * 从 ordered_section_group 配置中提取 IoTId 并构建 touConfig
 * 支持多种结构：
 * 1. sections -> section -> fields -> property_group -> fields -> property
 * 2. sections -> section -> fields -> property
 * 3. sections -> property_group (直接是 property_group，不经过 section)
 * @param {Array} sections - sections 数组
 * @returns {Array} touConfig 数组
 */
export const buildTouConfig = (sections) => {
  const touConfig = []

  // 递归提取 fields 中的 IoTId
  const extractIoTIds = (fields, currentTouItem) => {
    fields.forEach(field => {
      if (Array.isArray(field.fields) && field.fields.length > 0) {
        // 是 property_group 类型，递归提取其 fields
        extractIoTIds(field.fields || [], currentTouItem)
      } else if (field.type === 'property' && field.IoTId) {
        // 直接是 property 类型
        currentTouItem[field.IoTId] = ""
      }
    })
  }

  // 遍历每个 section 生成空对象
  sections.forEach((section) => {
    const touItem = {}
    if (Array.isArray(section.fields) && section.fields.length > 0) {
      extractIoTIds(section.fields || [], touItem)
    }
    touConfig.push(touItem)
  })

  return touConfig
}

// 统一处理组件输入精度
export const handleAdvancedInputPrecision = (item) => {
  let precision = 0;
  if (!isEmpty(item.scale)) {
    precision = Number(item.scale);
  } else if (item.step) {
    // 处理 step 类型，提取小数部分的长度
    // 例如：step.001 为 3
    let parts = item.step.toString().split('.');
    precision = parts.length === 2 ? parts[1].length : 0;
  }
  return precision;
}

// 生成一个地址处理函数，给定一个item，里边可能有country,province,city,district,street,houseNumber等字段，如果这些字段都为空，返回空字符串
// 则返回一个函数，当调用时，根据 item 中的字段值，返回一个格式化后的地址字符串
export const getAddress = (item, separator = ' / ') => {
  // 定义字段映射：显示名称 -> 可能的字段名（按优先级）
  const fieldMap = {
    country: ['country', 'area', 'plantCountry', 'nation'],
    province: ['province', 'plantProvince', 'state'],
    city: ['city', 'plantCity', 'town'],
    district: ['district', 'plantDistrict', 'county'],
    street: ['street', 'plantStreet', 'road'],
    houseNumber: ['houseNumber', 'houseNo', 'number']
  }

  const getFieldValue = (item, possibleKeys) => {
    for (const key of possibleKeys) {
      const value = item[key]
      if (value) return value
    }
    return null
  }

  const fields = ['country', 'province', 'city', 'district', 'street', 'houseNumber']
  return fields
    .map(field => getFieldValue(item, fieldMap[field] || [field]))
    .filter(Boolean)
    .join(separator)
}

/**
 * 解析地址级联组件的值，提取各级ID到目标对象
 * @param {Object} target - 目标对象（会被修改）
 * @param {string} fieldName - 地址字段名，默认 'addressInfo'
 * @returns {Object} 目标对象
 */
export const parseAddressInfo = (target, fieldName = 'addressInfo') => {
  const info = target[fieldName];

  if (info && typeof info === 'object') {
    // 统一使用小写后缀进行匹配
    const addressSuffixes = ['countryid', 'provinceid', 'cityid', 'districtid', 'streetid'];

    Object.keys(info).forEach((key) => {
      const lowerKey = key.toLowerCase();
      const matched = addressSuffixes.some((suffix) => lowerKey.endsWith(suffix));

      if (matched && info[key] !== undefined && info[key] !== null) {
        target[key] = info[key];
      }
    });

    delete target[fieldName];
  }

  return target;
};
